import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="toggle-box"
export default class extends Controller {
  static targets = ["box"]

  connect() {
  }

  toggle() {
    this.boxTarget.classList.toggle("hidden")
  }

  show() {
    this.boxTarget.classList.remove("hidden")
  }

  hide() {
    this.boxTarget.classList.add("hidden")
  }
}
